<template>
    <div class="box">
        <div class="header">
            <div class="header-content">
                <div
                    class="back"
                    @click="$router.go(-1)"
                >
                    <img
                        src="../assets/back.png"
                        style="width: 1.4rem;height:1.4rem"
                    />
                    <!-- <div class="welMsg1">返回</div> -->
                </div>
                <span class="welMsg2">加入红娘</span>
            </div>
        </div>
        <div class="content-introduce">
            <div class="rules-section">
                <!-- <div class="rules-title">加入鹊桥会红娘</div> -->
                <div class="rules-content">
                    <div class="rules-block">
                        <div class="rules-block-title">一、注册基本条件</div>
                        <div class="rules-item">1. 婚姻状态：申请人不能为未婚（系统显示未婚者不允许注册为红娘）。</div>
                        <div class="rules-item">2. 注册时必须填写真实有效的个人信息，包括工号、姓名、部门等。</div>
                        <div class="rules-item">3. 上传本人高清正面照片，优先使用证件照。</div>
                    </div>
                    <div class="rules-block">
                        <div class="rules-block-title">二、红娘岗位职责</div>
                        <div class="rules-item">1. 积极为单身会员牵线搭桥，推荐合适的交友对象。</div>
                        <div class="rules-item">2. 跟进已推荐配对双方的交友进展，及时记录跟进状态。</div>
                        <div class="rules-item">3. 维护鹊桥会平台的良好氛围，促进健康交友。</div>
                    </div>
                    <div class="rules-block">
                        <div class="rules-block-title">三、入会要求</div>
                        <div class="rules-item">1. 热心公益，乐于助人，有良好的沟通能力。</div>
                        <div class="rules-item">2. 能够投入一定时间和精力参与红娘工作。</div>
                        <div class="rules-item">3. 遵守鹊桥会相关规章制度。</div>
                    </div>
                    <div class="rules-block">
                        <div class="rules-block-title">四、提交即视为同意</div>
                        <div class="rules-item">提交本申请即表示您已阅读并同意以上条款，愿意遵守鹊桥会红娘的相关规定，并接受平台的审核与管理。</div>
                    </div>
                </div>
            </div>
            <div class="content-form">
                <van-form>
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">1.工作所在区域</van-col>
                    </van-row>
                    <van-radio-group
                        :disabled="COMPANYNAME=='PTL'"
                        v-model="info.workArea"
                        :rules="[{ required: true, message: '请选择工作所在区域' }]"
                        error
                    >
                        <van-radio
                            name="1"
                            icon-size="0.6rem"
                            v-if="isAtl2"
                        >W区</van-radio>
                        <van-radio
                            name="2"
                            icon-size="0.6rem"
                            v-if="isAtl2"
                        >E区</van-radio>
                        <van-radio
                            name="3"
                            icon-size="0.6rem"
                            v-if="isAtl2"
                        >M区</van-radio>
                        <van-radio
                            name="4"
                            icon-size="0.6rem"
                            v-if="isAtl2"
                        >R区</van-radio>
                        <van-radio
                            name="15"
                            icon-size="0.6rem"
                        >东莞</van-radio>
                    </van-radio-group>
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">2.所在部门</van-col>
                    </van-row>
                    <van-field v-model="info.department" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">3.工号</van-col>
                    </van-row>
                    <van-field
                        v-model="info.employeeNo"
                        :disabled="disabled"
                    />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">4.姓名</van-col>
                    </van-row>
                    <van-field
                        v-model="info.name"
                        :disabled="disabled"
                    />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">5.性别</van-col>
                    </van-row>
                    <van-radio-group
                        v-model="info.sex"
                        :disabled="disabled"
                    >
                        <van-radio
                            name="1"
                            icon-size="0.6rem"
                        >男</van-radio>
                        <van-radio
                            name="2"
                            icon-size="0.6rem"
                        >女</van-radio>
                    </van-radio-group>
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">6.手机号码</van-col>
                    </van-row>
                    <van-field v-model="info.contactNumber" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">7.直属上级</van-col>
                    </van-row>
                    <van-field v-model="info.immediateSuperior" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">8.微信号</van-col>
                    </van-row>
                    <van-field v-model="info.weChatNumber" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">9.自我介绍</van-col>
                    </van-row>
                    <van-field v-model="info.selfIntroduction" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">10.个人特长</van-col>
                    </van-row>
                    <van-field v-model="info.personalStrength" />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem;margin-bottom: 0.2rem">11.照片上传</van-col>
                    </van-row>
                    <van-row
                        class="upload"
                        justify="space-between"
                    >
                        <van-col
                            span="24"
                            class="upload-note"
                            style="color: #666"
                        >
                            高清正脸，优先证件照
                            <br />
                            <span style="color: #999">支持jpg,png,gif,bmp,psd,tiff等图片格式。</span>
                            <br />
                            <span style="color: #999">建议使用1:1尺寸照片</span>
                        </van-col>
                    </van-row>
                    <van-uploader
                        accept="image/*"
                        :max-count="1"
                        v-model="info.personalPhotos"
                        class="van-upload"
                        :before-read="onSelectAvatar"
                        :before-delete="idBeforeDelete"
                    />
                    <van-row
                        class="van-row van-star"
                        justify="space-between"
                    >
                        <van-col style="font-size: 0.6rem">12.加入红娘的原因</van-col>
                    </van-row>
                    <van-checkbox-group v-model="info.reasonForJoining">
                        <van-checkbox
                            name="1"
                            shape="square"
                            icon-size="0.6rem"
                        >有公益心、热心肠，愿意成人之美</van-checkbox>
                        <van-checkbox
                            name="2"
                            shape="square"
                            icon-size="0.6rem"
                        >身边单身人员资源较多</van-checkbox>
                        <van-checkbox
                            name="3"
                            shape="square"
                            icon-size="0.6rem"
                        >日常工作接触人员较多，对部门或区域人员情况有一定了解</van-checkbox>
                    </van-checkbox-group>
                </van-form>
            </div>
        </div>
        <div
            class="submit"
            @click="onSubmit"
        >提交</div>

        <avatar-cropper
            :visible.sync="cropperVisible"
            :img-src="rawImgSrc"
            @confirm="onCropConfirm"
        />
    </div>
</template>
<script>
import { getOaInfo } from "@/utils/auth";
import { Toast } from "vant";
import { submitMatchMakerInfo, upLoadImages } from "../api/user";
import AvatarCropper from "../components/AvatarCropper.vue";
export default {
    components: { AvatarCropper },
    data() {
        return {
            COMPANYNAME: process.env.COMPANYNAME,
            ChineseCOMPANYNAME: process.env.ChineseCOMPANYNAME,
            disabled: false,
            info: {
                avatarLink: "",
                department: "",
                workArea: "",
                employeeNo: "",
                name: "",
                sex: "",
                contactNumber: "",
                immediateSuperior: "",
                reasonForJoining: [],
                personalPhotos: [],
                selfIntroduction: "",
                personalStrength: "",
                weChatNumber: ""
            },
            cropperVisible: false,
            rawImgSrc: ''
        };
    },
    computed: {
        isAtl2() {
            return this.COMPANYNAME == "ATL";
        }
    },
    methods: {
        // 添加照片 — 打开裁剪弹窗
        onSelectAvatar(file) {
            const reader = new FileReader();
            reader.onload = e => {
                this.rawImgSrc = e.target.result;
                this.cropperVisible = true;
            };
            reader.readAsDataURL(file);
            return false;
        },
        // 裁剪确认后上传
        async onCropConfirm(blob) {
            const localUrl = URL.createObjectURL(blob);
            this.info.personalPhotos = [{ url: localUrl }];
            this.info.avatarLink = localUrl;
            const formData = new FormData();
            formData.append('formFile', blob, 'avatar.jpg');
            try {
                const res = await upLoadImages(formData);
                URL.revokeObjectURL(localUrl);
                if (res && res.code === 20000) {
                    this.info.personalPhotos = [{ url: res.data }];
                    this.info.avatarLink = res.data;
                    Toast({ message: '上传成功' });
                } else {
                    this.info.personalPhotos = [];
                    this.info.avatarLink = '';
                    Toast({ message: '上传失败' });
                }
            } catch (e) {
                URL.revokeObjectURL(localUrl);
                this.info.personalPhotos = [];
                this.info.avatarLink = '';
                Toast({ message: '上传失败' });
            }
        },
        // 删除照片
        idBeforeDelete(file, detail) {
            this.info.personalPhotos.splice(detail.index, 1);
            this.info.avatarLink = "";
        },
        // 提交申请红娘，对手机号与填写信息判断
        onSubmit() {
            if (this.info.contactNumber) {
                let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if (!reg_tel.test(this.info.contactNumber)) {
                    Toast.fail({
                        message: "请输入正确的手机号",
                        className: "phoneErrMessage"
                    });
                    return;
                }
            }
            for (var item in this.info) {
                if (
                    !this.info[`${item}`] ||
                    this.info[`${item}`].length === 0
                ) {
                    Toast({
                        message: "存在未填写信息，请填写完后提交"
                    });
                    return;
                }
            }
            const data = {
                ...this.info
            };
            submitMatchMakerInfo(data).then(res => {
                if (res.code === 20000) {
                    Toast.success({
                        message:
                            "您好，已收到您的红娘报名申请，稍候将有专人电话跟您联系，谢谢！",
                        className: "createSuccessInfo"
                    });
                    this.$store
                        .dispatch("SetToken", res.data.token)
                        .then(() => {
                            this.$store.dispatch("GetInfo", true).then(() => {
                                this.$router.push({ path: "/homePage" });
                            });
                        });
                } else {
                    Toast.fail({
                        message: "提交失败"
                    });
                }
            });
        }
    },
    created() {
        // 初始化数据获取本地会话缓存是否有用户数据，如果有给对应数据赋值，并禁止修改
        let data = getOaInfo();
        if (data) {
            this.disabled = true;
            // Object.assign(this.info,data)
            // this.info.isAtl = '1';
            // this.info.birthday = data.birthDate.substr(0,7);  //生日
            this.info.name = data.name; //名字
            this.info.department = data.organizationName; // 部门
            this.info.employeeNo = data.userName; // 工号
            this.info.immediateSuperior = data.directManagerEmployeeName; // 直属上级，有可能没有。
            // this.info.entryDate = data.entryDate.substr(0,7);; // 入职日期
            // this.info.positionTitle = data.position; // 岗位名称
            this.info.sex = data.gender === "男" ? "1" : "2"; // 性别
            // let workArea = ''
            // switch (data.workPlace) {
            //   case "W区":
            //     workArea = '1';
            //     break;
            //   case "E区":
            //     workArea = '2';
            //     break;
            //   case "M区":
            //     workArea = '3';
            //     break;
            //   case "R区":
            //     workArea = '4';
            //     break;
            //   default:
            //     workArea = '1';
            //     break;
            // }
            // this.info.workArea = workArea;
        }
        if (!this.isAtl2) {
            // alert(123);
            this.info.workArea = "15";
        }
    }
};
</script>
<style scoped lang="less" src="../style/joinMatchMaker.less" />



// WEBPACK FOOTER //
// src/views/joinMatchMaker.vue